export type SGPBadgeProps = {
    className?: string;
    fillBackground: string;
    fill: string;
};

export const SGPBadgeDark: SGPBadgeProps = {
    fillBackground: 'none',
    fill: '#53D337'
};

export const SGPBadgeLight: SGPBadgeProps = {
    fillBackground: '#F1FBEE',
    fill: '#2A751A'
};
